exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon-spin {\r\n    -webkit-animation: icon-spin 2s infinite linear;\r\n    animation: icon-spin 2s infinite linear;\r\n}\r\n\r\n.icon-pulse {\r\n    -webkit-animation: icon-spin 1s infinite steps(8);\r\n    animation: icon-spin 1s infinite steps(8);\r\n}\r\n\r\n@-webkit-keyframes icon-spin {\r\n    0% {\r\n        -webkit-transform: rotate(0deg);\r\n        transform: rotate(0deg);\r\n    }\r\n\r\n    100% {\r\n        -webkit-transform: rotate(360deg);\r\n        transform: rotate(360deg);\r\n    }\r\n}\r\n\r\n@keyframes icon-spin {\r\n    0% {\r\n        -webkit-transform: rotate(0deg);\r\n        transform: rotate(0deg);\r\n    }\r\n\r\n    100% {\r\n        -webkit-transform: rotate(360deg);\r\n        transform: rotate(360deg);\r\n    }\r\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./ClientApp/css/animations.css
// module id = 636
// module chunks = 0